import React from 'react';
import { BrowserRouter, Route } from 'react-router-dom';

import ProjectListing from './pages/ProjectListing';

export default () => (
        <Route path="/" component={ProjectListing} />
);
